class Transferencias{
  constructor(){
    this.id = null;
    this.transacao = '';
    this.estoque = '';
    this.notaEspecie = '';
    this.notaSerie = '';
    this.notaNumero = '';
    this.notaDataEmissao = '';
    this.notaValorDedutivel = '';
    this.notaArquivo = '';
    this.nomeArquivo = '';
    this.tipoArquivo = '';
    this.obraOrigemConsulta = '';
    this.obraDestinoConsulta = '';

    this.notaDataEmissaoFormatada = '';
    this.saldoDedutivelFormatado = '';
    this.tipoTransacaoFormatada = '';
    this.notaEspecieFormatada = '';
    this.estoqueMateriaisFormatado = '';

    //JOINS
    this.idContribFornecedor = null;
    this.idObras = null;
    this.idObraDestino = null;
  }
}

export default Transferencias;